// extracted by mini-css-extract-plugin
module.exports = {"lab-icon":"lab-icon_lab-icon__ZAbnD","completed":"lab-icon_completed__l_XFW"};